import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { catchError, Observable, retry } from 'rxjs';
import { MachineTypeModel } from 'src/app/models/machines/machine-type';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';
import { toFormData } from 'src/app/components/mits-files-upload/mits-files-upload-select/helpers/formDataParser';

@Injectable({
  providedIn: 'root',
})
export class MachineTypeService extends OfflineDataService<MachineTypeModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'Machines::MachineType',
      http,
      errorService,
      events,
      'machines/machine_types/',
      'machine_type',
      ['created_at', 'updated_at', 'created_by_id'],
      []
    );
  }

  override saveRemote(object: MachineTypeModel, queueId: string|null = null): Observable<MachineTypeModel> {
    if (object.id === null) {
      delete object.id;
    }
    object?.machine_type_documents?.map((doc) => {
      if (doc.release_date) {
        doc.release_date = new Date(doc.release_date).toISOString();
      }
    });

    const checklistIds = object.checklist_ids ?? [];
    (object as any).checklist_ids = undefined;

    const form = toFormData(object, this, object.id !== undefined && object.id >= 0 ? ['file'] : ['image']);
    if (checklistIds.length === 0) {
      form.append('machine_type[checklist_ids][]', '');
    } else {
      for (const id of checklistIds) {
        form.append('machine_type[checklist_ids][]', String(id));
      }
    }

    if (object.id !== undefined && object.id >= 0) {
      return this.http
        .put<MachineTypeModel>(this.endpointWithUrl + object.id, form)
        .pipe(retry(1), catchError(this.errorService.convert));
    } else {
      return this.http
        .post<MachineTypeModel>(this.endpointWithUrl, form)
        .pipe(retry(1), catchError(this.errorService.convert));
    }
  }
}
